import {action, makeAutoObservable} from "mobx"
import {ActionAnswer} from "../../utils/RequestsHelper"
import {Node} from "react-checkbox-tree"
import {AxiosResponse} from "axios"
import {noticeController} from "../../utils/NoticeController"
import ChooseCategoriesApi, {
    CategoryNestedSet,
    ChooseCategoriesGet,
    productExportConditions
} from "../../api/ChooseCategoriesApi"

const expandedCategoriesStorageName = 'ChoiceControllerExpandedCategories'

class ChoiceController {
    constructor() {
        makeAutoObservable(this)
    }

    private _exportAll: boolean = true

    get exportAll(): boolean {
        return this._exportAll
    }

    set exportAll(value: boolean) {
        this._exportAll = value
    }

    private _type: string = ''

    get type(): string {
        return this._type
    }

    set type(value: string) {
        this._type = value
    }

    private _checkedCategories: string[] = []

    get checkedCategories(): string[] {
        return this._checkedCategories
    }

    set checkedCategories(value: string[]) {
        this._checkedCategories = value
    }

    private _chosenSets: { label: string, value: string }[] = []

    get chosenSets(): { label: string; value: string }[] {
        return this._chosenSets
    }

    set chosenSets(value: { label: string; value: string }[]) {
        this._chosenSets = value
    }

    private _exportConditions: productExportConditions = {
        hidden: true,
        unavailable: true,
        infinity: true,
        minPrice: 0
    }

    get exportConditions(): productExportConditions {
        return this._exportConditions
    }

    set exportConditions(value: productExportConditions) {
        this._exportConditions = value
    }

    loadSettings() {
        // let expandedCategoriesFromStorage = localStorage.getItem(expandedCategoriesStorageName)
        // let findExpandedCategories = false
        // if (expandedCategoriesFromStorage) {
        //     this._expandCategories = JSON.parse(expandedCategoriesFromStorage)
        // } else {
        //     findExpandedCategories = true
        // }

        ChooseCategoriesApi.get().then(action("settingsLoaded", data => {
            this._updateValues(data)
            if (this.chosenSets.length > 0) {
                this._type = "sets"
            }
            if (this.checkedCategories.length > 0) {
                this._type = 'categories'
            }

        }))
        ChooseCategoriesApi.getProductExportConditions().then((result) => {
            this.exportConditions = result.data.data
        })
    }


    saveSelectedCategories() {
        ChooseCategoriesApi.saveCategories(this.checkedCategories).then(data => this._updateValues(data))
    }

    saveSelectedSets() {
        const values = []
        for (const chosenSet of this.chosenSets) {
            values.push(chosenSet.value)
        }
        ChooseCategoriesApi.saveSets(values).then(data => this._updateValues(data))
    }

    saveExportAll() {
        ChooseCategoriesApi.saveExportAll(this.exportAll).then(data => this._updateValues(data))
    }

    setExportCondition(param: "hidden" | "unavailable" | "infinity" | "minPrice", value: boolean | number) {
        if (this.exportConditions) {
            this.exportConditions = {
                ...this.exportConditions,
                [param]: value
            }
            // ChooseCategoriesApi.saveProductExportConditions(this.exportConditions)
        }
    }

    saveAll(){
        noticeController.clearSuccess()
        const values = []
        for (const chosenSet of this.chosenSets) {
            values.push(chosenSet.value)
        }
        const params = {
            'exportAll': this.exportAll ? 1 : 0,
            'conditions' : this.exportConditions,
            'sets': values,
            'categories': this.checkedCategories,
            'type': this.type,
        }

        return ChooseCategoriesApi.saveAll(params).then(data => {
            noticeController.success = ['Сохранено']
            setTimeout(()=>noticeController.clearSuccess(), 1000)
        })
    }


    private _updateValues(data: AxiosResponse<ActionAnswer<ChooseCategoriesGet>>) {
        const result = data.data.data
        this.exportAll = result.exportAll
        this.checkedCategories = result.categories_to_export

        this.chosenSets = result.sets_to_export
    }


}


const choiceController = new ChoiceController()
export default choiceController